import { Button, HStack, IconButton, Text } from "@chakra-ui/react";
import React, { memo, useMemo } from "react";

import colors from "app/colors";
import { ForwardIcon } from "modules/icons";
import { MessageFragment, MessageThreadFragment } from "gql/graphql";
import SyncoTooltip from "../../../_shared/synco-tooltip";
import useForwardMessage from "modules/hooks/use-forward-message";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
  displayText?: string;
}

const MessagePopoverForwardMessageButton: React.FC<IProps> = ({
  messageThread,
  message,
  displayText,
}) => {
  const { createLinkedThread } = useForwardMessage({ messageThread, message });

  const isVisible = useMemo(
    () => !messageThread.isLocked,
    [messageThread.isLocked],
  );

  if (!isVisible) {
    return null;
  }

  if (displayText) {
    return (
      <Button variant="link" onClick={createLinkedThread}>
        <HStack spacing={2}>
          <ForwardIcon boxSize={5} fill={colors.blue} />
          <Text fontSize={14} color={colors.blackSecondary}>
            {displayText}
          </Text>
        </HStack>
      </Button>
    );
  }

  return (
    <SyncoTooltip
      label="Forward Message"
      wrapInBox={false}
      openDelay={1000}
      placement="top-end"
    >
      <IconButton
        variant="link"
        icon={<ForwardIcon boxSize={5} fill={colors.blue} />}
        onClick={createLinkedThread}
        aria-label="forward"
      />
    </SyncoTooltip>
  );
};

export default memo(MessagePopoverForwardMessageButton);
